import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { cn } from '../lib/utils'

interface LogoCloudProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function LogoCloud({ component, locale, style }: LogoCloudProps) {
  const config = component.config as any

  const title = getLocalizedText(config.title, locale)
  const subtitle = getLocalizedText(config.subtitle, locale)
  const logos = config.logos || []
  const columns = config.columns || 5
  const grayscale = config.grayscale || false

  const gridColsMap = {
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-4',
    5: 'md:grid-cols-5',
    6: 'md:grid-cols-6',
  }
  const gridCols = gridColsMap[columns as keyof typeof gridColsMap] || 'md:grid-cols-5'

  return (
    <div style={style} className="w-full">
      <div className="max-w-7xl mx-auto">
        {(title || subtitle) && (
          <div className="text-center mb-12">
            {title && (
              <h2 className="text-3xl font-bold mb-4" style={{ color: style.color }}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-lg opacity-80" style={{ color: style.color }}>
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className={cn('grid grid-cols-2 gap-8 items-center', gridCols)}>
          {logos.map((logo: any, index: number) => (
            <div
              key={index}
              className="flex items-center justify-center p-4 transition-transform hover:scale-110"
            >
              {logo.website ? (
                <a href={logo.website} target="_blank" rel="noopener noreferrer">
                  <img
                    src={logo.imageUrl}
                    alt={logo.name}
                    className="max-h-12 w-auto object-contain"
                    style={{
                      filter: grayscale ? 'grayscale(100%)' : 'none',
                      opacity: grayscale ? 0.7 : 1,
                    }}
                  />
                </a>
              ) : (
                <img
                  src={logo.imageUrl}
                  alt={logo.name}
                  className="max-h-12 w-auto object-contain"
                  style={{
                    filter: grayscale ? 'grayscale(100%)' : 'none',
                    opacity: grayscale ? 0.7 : 1,
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
